import { h, Fragment } from 'preact';
import { useEffect, useState } from 'preact/hooks';
import { DATA_EVENTS, INTERNAL_EVENTS, SDK_EVENTS } from '../../../constants/events.cnst';
import { ClassMapConstanst, ProjConstants, RenderResponseType, Tabs } from '../../../constants/projConsts';
import KoreGenerateuuidPipe from '../../../utils/koregenerateuuid';
import RandomuuidPipe from '../../../utils/randomuuid';
import { getHTML } from '../../base/domManager';
import { addInterruptDropdownItem } from '../atom/dialogPopups';
import { AskCustomer, Automation, MybotAttachmentAskCustomer } from '../automation/automation';
import { addScrollButtons } from '../../../utils/scrollUtils';
import { ERROR_CODES } from '../../../constants/errorcodes';

export function RenderEmptyMyBotScreen(props: any) {
    const languageData = props?.hostInstance?.languagedata;
    return (
        <div className="empty-listing-triggers aa-mybot-empty">
            <h1 className="aa-text-sm medium">{languageData?.MYBOT_TRIGGET_LISTEN}</h1>
            <p className="aa-desc-xs center">{languageData?.MYBOT_EMTPY_MSG}</p>
        </div>
    )
}

export function RenderMybotHeaderLeftSections(props: any) {
    const languageData = props?.hostInstance?.languagedata
    return (
        <>
            <div className="left-title-info">
                <div className="text-dropdown-info">
                    <h1 className="m-0">{languageData?.MY_BOT}</h1>
                    <div className={`interrupt-wrapper aa-mybot-interrupt-wrapper aa-hidden`}>
                        <span className="dialogs-number aa-mybot-interrupt-length">2</span>
                        <div className="aa-dropdown aa-mybot-interrupt-dropdown-wrapper">
                            <button type="button" className="aa-dropdown-toggle aa-mybot-interrupt-toggle" id="playbookDrp">
                                <svg className="arrow-icon aa-selected-checklist-arrow" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M3.52876 5.52858C3.78911 5.26823 4.21122 5.26823 4.47157 5.52858L8.00016 9.05717L11.5288 5.52858C11.7891 5.26823 12.2112 5.26823 12.4716 5.52858C12.7319 5.78892 12.7319 6.21103 12.4716 6.47138L8.47157 10.4714C8.21122 10.7317 7.78911 10.7317 7.52876 10.4714L3.52876 6.47138C3.26841 6.21103 3.26841 5.78892 3.52876 5.52858Z" fill="#667085" />
                                </svg>
                            </button>
                            <div className="aa-dropdown-content playbook-dropdown-content aa-p-0 aa-mybot-interrupt-dropdown-content" aria-labelledby="playbookDrp">
                                <div className="heading-text-scripts">{languageData?.INTERRUPT_DIALOG}</div>

                            </div>
                        </div>

                    </div>
                </div>
                <div className="bottom-titles aa-mybot-header-dialog-wrapper aa-hidden">
                    <p className="text-truncate aa-text-xs aa-mybot-header-dialog-name"></p>
                    <div className="entity-name-cstm">
                        <span className="aa-desc-xs medium">{languageData?.STEP}:</span>
                        <span className="aa-text-xs medium text-truncate aa-mybot-header-entity-name"></span>
                    </div>
                </div>
            </div>
        </>
    )
}

export function RenderMybotHeaderRightSection(props: any) {
    return (
        <>
            <div className="actions-assist-header">
                <button className="solid-action aa-mybot-listview-btn aa-hidden" aria-label="button">
                    <svg width="13" height="12" viewBox="0 0 13 12" fill="none">
                        <path d="M8.31583 6.00268C8.31583 5.78877 8.14241 5.61536 7.9285 5.61536H4.40105L4.3658 5.61694C4.1684 5.63475 4.01372 5.80065 4.01372 6.00268C4.01372 6.2166 4.18714 6.39001 4.40105 6.39001H7.9285L7.96375 6.38843C8.16115 6.37062 8.31583 6.20471 8.31583 6.00268Z" fill="#101828" />
                        <path d="M8.31583 7.76641C8.31583 7.55249 8.14241 7.37908 7.9285 7.37908H4.40105L4.3658 7.38066C4.1684 7.39847 4.01372 7.56437 4.01372 7.76641C4.01372 7.98032 4.18714 8.15373 4.40105 8.15373H7.9285L7.96375 8.15215C8.16115 8.13434 8.31583 7.96844 8.31583 7.76641Z" fill="#101828" />
                        <path d="M7.14001 4.23896C7.14001 4.02504 6.9666 3.85163 6.75268 3.85163H4.40105L4.3658 3.85321C4.1684 3.87102 4.01372 4.03693 4.01372 4.23896C4.01372 4.45287 4.18714 4.62629 4.40105 4.62629H6.75268L6.78794 4.6247C6.98533 4.60689 7.14001 4.44099 7.14001 4.23896Z" fill="#101828" />
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M3.22524 1.5H9.10431C9.64284 1.5 10.0795 1.93612 10.0795 2.47485V9.52515C10.0795 10.0639 9.64284 10.5 9.10431 10.5H3.22524C2.68671 10.5 2.25 10.0639 2.25 9.52515V2.47485C2.25 1.93612 2.68671 1.5 3.22524 1.5ZM9.10431 2.27466H3.22524C3.11431 2.27466 3.02466 2.36419 3.02466 2.47485V9.52515C3.02466 9.63581 3.11431 9.72534 3.22524 9.72534H9.10431C9.21524 9.72534 9.30489 9.63581 9.30489 9.52515V2.47485C9.30489 2.36419 9.21524 2.27466 9.10431 2.27466Z" fill="#101828" />
                    </svg>
                </button>
                <button className="solid-action aa-mybot-restart-btn aa-hidden" aria-label="button">
                    <svg width="13" height="12" viewBox="0 0 13 12" fill="none">
                        <path d="M6.56883 0.838644C6.41593 0.712508 6.1893 0.720994 6.04633 0.864052L6.02111 0.891816C5.89497 1.04471 5.90346 1.27134 6.04651 1.41431L6.77241 2.13974C4.27202 2.15882 2.25 4.19131 2.25 6.6948C2.25 9.21013 4.2912 11.25 6.80791 11.25C9.32463 11.25 11.3658 9.21013 11.3658 6.6948C11.3658 6.47992 11.1916 6.30571 10.9767 6.30571C10.7618 6.30571 10.5876 6.47992 10.5876 6.6948C10.5876 8.78024 8.89497 10.4718 6.80791 10.4718C4.72086 10.4718 3.02818 8.78024 3.02818 6.6948C3.02818 4.62198 4.70045 2.93826 6.77009 2.91797L6.04651 3.64128L6.02127 3.66902C5.89503 3.82183 5.90337 4.04848 6.04633 4.19153C6.19823 4.34353 6.44459 4.34361 6.59659 4.19171L7.9862 2.80301L8.01146 2.77525C8.13774 2.62237 8.12932 2.3956 7.9862 2.25257L6.59659 0.863872L6.56883 0.838644Z" fill="#101828" />
                    </svg>
                </button>

                <button className="solid-action stop-assist aa-mybot-terminate-btn aa-hidden" aria-label="button">
                    <span></span>
                </button>
            </div>
        </>
    )
}

export function MyBot({ hostInstance }: any) {
    const [mybotResponseArray, setMybotResponseArray] = useState<any>([]);
    const rootServiceInstance = hostInstance.rootService;
    const localStorageServiceInstance = hostInstance.localStorageService;
    const [interruptDialog, setInterruptDialog] = useState({});
    const [interruptRun, setInterruptRun] = useState(false);
    const [showErrorPrompt, setShowErrorPrompt] = useState(false);

    const classConstants: any = ClassMapConstanst;
    let currentEntityNode : any = null;
    let templateClick = false;

    useEffect(() => {

        initializeUI();
        registerEventListeners();
        fetchMybotData();
        return () => {
            unregisterEventListeners();
        };
    }, []);

    useEffect(() => {
        rootServiceInstance.handleMybotScroll(hostInstance);
        if (mybotResponseArray?.length > 0) {
            hideEmptyScreen();
        }
    }, [mybotResponseArray]);

    useEffect(() => {
        handleDialogInterrupt(interruptDialog);
    }, [interruptDialog]);

    const initializeUI = () => {
        addEmptyScreen();
        addMybotHeader();
        addMybotScrollButtons();
    };

    const registerEventListeners = () => {
        hostInstance.on(DATA_EVENTS.AGENT_AI_AGENT_RESPONSE, handleAgentAssistAgentResponse);
        hostInstance.on(DATA_EVENTS.END_OF_TASK_RESPONSE, handleEndOfTaskResponse);
        hostInstance.on(INTERNAL_EVENTS.TEMPLATE_CLICK, handleTemplateClickEvents);
        listenInterruptEvents();
        listenTerminateEvents();
        listenRunClickEvents();
    };

    const listenTerminateEvents = () => {
        const handleTerminateEvent = () => {
            const lastAutomation: any = getLastAutomation();
            if (rootServiceInstance.isMyBotAutomationOnGoing) {
                rootServiceInstance.sendRunClickEvent(hostInstance, { intentName: ProjConstants.DISCARD_ALL, sourceMsgId: lastAutomation.sourceMsgId, positionId: lastAutomation.positionId, agentRunButton: true });
            }
            rootServiceInstance.toggleTerminatePopup(hostInstance, false);
        };

        const handleTerminateOverrideEvent = () => {
            rootServiceInstance.manualAssistOverrideMode = true;
            hostInstance.handleOverrideMode(true, null);
            rootServiceInstance.toggleTerminatePopup(hostInstance, false);
            showOrHideLastNodeActionButtons(false);
        };

        hostInstance.on(INTERNAL_EVENTS.TERMINATE_EVENT, (data: any) => {
            if (data?.activeTab === Tabs.MYBOT) {
                handleTerminateEvent();
            }
        });

        hostInstance.on(INTERNAL_EVENTS.TERMINATE_OVERRIDE_EVENT, (data: any) => {
            if (data?.activeTab === Tabs.MYBOT) {
                handleTerminateOverrideEvent();
            }
        });

    };

    const listenInterruptEvents = () => {
        const openInterruptPopup = (runEventObj: any) => {
            if (runEventObj.agentRunButton) {
                setInterruptDialog({ ...runEventObj });
            }
        };

        const handleInterruptRun = (data: any) => {
            if (data?.activeTab === Tabs.MYBOT) {
                rootServiceInstance.toggleInterruptPopup(hostInstance, false);
                const lastAutomation: any = getLastAutomation();

                if (rootServiceInstance.isMyBotAutomationOnGoing) {
                    setInterruptRun(true);
                    rootServiceInstance.sendRunClickEvent(hostInstance, { intentName: ProjConstants.DISCARD_ALL, sourceMsgId: lastAutomation.sourceMsgId, positionId: lastAutomation.positionId, agentRunButton: true });
                }
            }
        };

        const handleInterruptRunLater = (data: any) => {
            if (data?.activeTab === Tabs.MYBOT) {
                let interruptedDialog: any = {};
                setInterruptDialog((dialog: any) => {
                    dialog.from = ProjConstants.INTERRUPT;
                    interruptedDialog = dialog;
                    return dialog;
                });

                const interruptDropdownContainer = hostInstance?.chatEle?.querySelector(ClassMapConstanst.MYBOT_INTERRUPT_DROPDOWN_CONTENT);

                if (!isDialogInInterruptList(interruptedDialog)) {
                    rootServiceInstance.mybotInterruptDialogList.push(interruptedDialog);
                    showInterruptDropdown(interruptDropdownContainer, interruptedDialog);
                    addRunClickEventListener(interruptedDialog, interruptDropdownContainer);
                }

                rootServiceInstance.toggleInterruptPopup(hostInstance, false);
            }
        };
        hostInstance.on(INTERNAL_EVENTS.INTERRUPT_POPUP_EVENT, openInterruptPopup);
        hostInstance.on(INTERNAL_EVENTS.INTERRUPT_ACCEPT_EVENT, handleInterruptRun);
        hostInstance.on(INTERNAL_EVENTS.INTERRUPT_RUNLATER_EVENT, handleInterruptRunLater);
    };

    const isDialogInInterruptList = (dialog: any) => {
        return rootServiceInstance.mybotInterruptDialogList.findIndex((d: any) => d.intentName === dialog.intentName) !== -1;
    };

    const addRunClickEventListener = (interruptedDialog: any, container: any) => {
        hostInstance.eventManager?.addEventListener(`${ClassMapConstanst.INTERRUPT_DIALOG}${interruptedDialog?.positionId}`, 'click', () => {
            hostInstance.emit(INTERNAL_EVENTS.RUN_CLICK_EVENT, interruptedDialog);
            rootServiceInstance.toggleInterruptPopup(hostInstance, false);
        }, container);
    };

    const showInterruptDropdown = (interruptDropdownContainer: any, interruptedDialog: any) => {
        const interruptDropdownItem = getHTML(addInterruptDropdownItem, { hostInstance, dialog: interruptedDialog }, hostInstance);
        hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, interruptDropdownItem, {
            event: SDK_EVENTS.INTERRUPT_DROPDOWN_ITEM_TEMPLATE,
            data: interruptedDialog
        });
        interruptDropdownContainer.append(interruptDropdownItem);
        rootServiceInstance.toggleMybotInterruptDropdown(Tabs.MYBOT, hostInstance);
    };

    const listenRunClickEvents = () => {
        const handleRunClickEvent = (runEventObj: any) => {
            if (runEventObj && runEventObj.agentRunButton) {
                const footerTag = hostInstance.chatEle.querySelector(classConstants.FOOTER);
                hostInstance.openMybotTab(footerTag, true);
                if (!rootServiceInstance.isMyBotAutomationOnGoing) {
                    if (runEventObj.from === ProjConstants.INTERRUPT) {
                        removeDialogFromInterruptList(runEventObj);
                    }
                    // it should be just before updating in assist response
                    runEventObj.positionId = RandomuuidPipe('positionId');
                    addAutomationNodeInMybotResponse(runEventObj);
                    rootServiceInstance.runDialogForAssistOrMybot(hostInstance, runEventObj);
                } else {
                    hostInstance.emit(INTERNAL_EVENTS.INTERRUPT_POPUP_EVENT, runEventObj);
                }
            }
        };



        hostInstance.on(INTERNAL_EVENTS.RUN_CLICK_EVENT, handleRunClickEvent);
    };

    const addAutomationNodeInMybotResponse = (runEventObj: any) => {
        const responseId = KoreGenerateuuidPipe();
        const automationRenderResponse = rootServiceInstance.prepareAutomationReponse(runEventObj, responseId, ProjConstants.MYBOT);
        setMybotResponseArray((prevResponse: any) => [...prevResponse, automationRenderResponse]);
        addAutomationTemplate(automationRenderResponse);
    };


    const addAutomationTemplate = (automation: any) => {
        const automationHtml: any = getHTML(Automation, { dialog: automation, hostInstance }, hostInstance);
        hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, automationHtml, { event: SDK_EVENTS.DIALOG_WRAPPER, data: automation });

        appendToMybotSection(automationHtml);
        rootServiceInstance.addDialogTemplate(automation.automationNodes[0], automation, ProjConstants.MYBOT, hostInstance);
    };

    const appendToMybotSection = (html: HTMLElement) => {
        const mybotSection = hostInstance?.chatEle?.querySelector(classConstants.MYBOT_SECTION);
        if (mybotSection) {
            const clonedHtml = html.cloneNode(true) as HTMLElement; // Clone the HTML element
            mybotSection.append(clonedHtml); // Append the cloned element
        }
    };


    const removeDialogFromInterruptList = (runEventObj: any) => {
        const interruptDropdownContainer = hostInstance?.chatEle?.querySelector(ClassMapConstanst.MYBOT_INTERRUPT_DROPDOWN_CONTENT);
        const interruptDialogItem = interruptDropdownContainer.querySelector(`${ClassMapConstanst.INTERRUPT_DIALOG}${runEventObj.positionId}`);

        if (interruptDialogItem) {
            interruptDialogItem.remove();
        }
        rootServiceInstance.mybotInterruptDialogList.splice(runEventObj.index, 1);
        rootServiceInstance.toggleMybotInterruptDropdown(Tabs.MYBOT, hostInstance);
    };

    const unregisterEventListeners = () => {
        hostInstance.off(DATA_EVENTS.AGENT_AI_AGENT_RESPONSE, handleAgentAssistAgentResponse);
        hostInstance.off(DATA_EVENTS.END_OF_TASK_RESPONSE, handleEndOfTaskResponse);
        hostInstance.off(INTERNAL_EVENTS.TEMPLATE_CLICK, handleTemplateClickEvents);
    };

    const handleEndOfTaskResponse = (response: any) => {
        if (response.intType == 'myBot') {
            dialogTerminatedOrInterrupted();
            interruptDialogCheck();
        }
    };

    const interruptDialogCheck = () => {
        setInterruptRun((flag) => {
            if (flag) {
                setInterruptDialog((dialog) => {
                    hostInstance.emit(INTERNAL_EVENTS.RUN_CLICK_EVENT, dialog);
                    return dialog;
                });
                return false; // Reset interrupt run state
            }
            return flag;
        });
    };

    const dialogTerminatedOrInterrupted = (feedbackObj: any = {}, isHistory: boolean = false) => {
        const lastAutomation = getLastAutomation();
        rootServiceInstance.updateLocalStorageForMybot(hostInstance, lastAutomation, false);
        const dialogEndNode = rootServiceInstance.prepareDialogEndNodeResponse(lastAutomation.dialogId);
        const feedbackNode = rootServiceInstance.prepareFeedbackDataForDialog(lastAutomation, feedbackObj, isHistory);
        rootServiceInstance.closeListView(hostInstance);
        showOrHideLastNodeActionButtons(false, true);
        addNodeInAutomation(dialogEndNode);
        addNodeInAutomation(feedbackNode);
    };

    const addEmptyScreen = () => {
        let emptyScreenHtml = getHTML(RenderEmptyMyBotScreen, {}, hostInstance);
        hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, emptyScreenHtml, {
            event: SDK_EVENTS.MYBOT_EMPTY_TEMPLATE
        });
        hostInstance?.chatEle?.querySelector(`${classConstants.MYBOT_SECTION}`).append(emptyScreenHtml);
    }

    const hideEmptyScreen = () => {
        hostInstance?.chatEle?.querySelector(`${classConstants.MYBOT_EMPTY_SCREEN}`)?.classList?.add(classConstants.HIDE_ELEMENT);
    }

    const addMybotHeader = () => {
        let mybotLeftSectionHtml = getHTML(RenderMybotHeaderLeftSections, {}, hostInstance);
        let mybotRightSectionHtml = getHTML(RenderMybotHeaderRightSection, {}, hostInstance);
        hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, mybotLeftSectionHtml, {
            event: SDK_EVENTS.MYBOT_HEADER_LEFT_SECTION
        });
        hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, mybotRightSectionHtml, {
            event: SDK_EVENTS.MYBOT_HEADER_RIGHT_SECTION
        });
        let headerSection = hostInstance?.chatEle?.querySelector(`${classConstants.MYBOT_HEADER_SECTIONS}`);
        if (mybotLeftSectionHtml && mybotRightSectionHtml && headerSection) {
            headerSection.append(mybotLeftSectionHtml);
            headerSection.append(mybotRightSectionHtml);
            handleHeaderClickEvents(mybotLeftSectionHtml, mybotRightSectionHtml);
        }
    }

    const handleHeaderClickEvents = (mybotLeftSectionHtml: any, mybotRightSectionHtml: any) => {
        hostInstance?.eventManager?.addEventListener?.(`${classConstants.MYBOT_TERMINATE_BUTTON}`, 'click', (e: any) => {
            hostInstance?.chatEle?.querySelector?.(`${classConstants.TERMIANTE_POPUP}`).classList?.remove(classConstants.HIDE_ELEMENT);
            hostInstance?.chatEle?.querySelector?.(`${classConstants.TERMINATE_OVERRIDE_BTN}`)?.classList?.add(classConstants.HIDE_ELEMENT);
        }, mybotRightSectionHtml);

        hostInstance?.eventManager?.addEventListener?.(`${classConstants.MYBOT_LISTVIEW_BUTTON}`, 'click', (e: any) => {
            hostInstance?.chatEle?.querySelector?.(`${classConstants.LIST_VIEW_POPUP}`).classList?.remove(classConstants.HIDE_ELEMENT);
            formatListViewEntityList();

        }, mybotRightSectionHtml);

        hostInstance?.eventManager?.addEventListener?.(`${classConstants.MYBOT_RESTART_BUTTON}`, 'click', (e: any) => {
        }, mybotRightSectionHtml);

        hostInstance?.eventManager?.addEventListener?.(`${classConstants.MYBOT_INTERRUPT_TOGGLE_BTN}`, 'click', (e: any) => {
            mybotLeftSectionHtml?.querySelector(`${classConstants.MYBOT_INTERRUPT_DROPDOWN_WRAPPER}`)?.classList.toggle('show');
        }, mybotLeftSectionHtml);
    }

    const formatListViewEntityList = () => {
        let entityList: any = [];
        let automation = getLastAutomation();
        if (automation.type === RenderResponseType.AUTOMATION) {
            let automationNodes = automation.automationNodes;
            automationNodes.forEach((node: any) => {
                if (node.nodeType === RenderResponseType.ENTITY_NODE) {
                    entityList.push(node);
                }
            });
            cloneExistingAutomationToListView(entityList);
        }
    }

    const getLastAutomation = () => {
        let lastAutomation: any;
        setMybotResponseArray((prevResponse: any) => {
            lastAutomation = prevResponse[prevResponse?.length - 1];
            return prevResponse;
        });
        return lastAutomation
    };

    const cloneExistingAutomationToListView = (entityList: any) => {
        entityList.forEach((entity: any) => {
            let entityNode = hostInstance?.chatEle?.querySelector(`${classConstants.ASK_CUST_NODE}${entity.uuid}`);
            let clonedNode = entityNode.cloneNode(true);
            clonedNode.querySelector(`${classConstants.ENTITY_HEADER}`)?.remove();
            rootServiceInstance.handleEntityNodeClickEvents(clonedNode, entity, ProjConstants.MYBOT, hostInstance);
            let listViewWrapper: any = hostInstance?.chatEle?.querySelector(`${classConstants.LIST_VIEW_BODY}`);
            listViewWrapper?.append(clonedNode);
            if(clonedNode?.querySelector(`${classConstants.ENTITY_EXPAND_BTN}`)){
                addEventListenersForListView(clonedNode);
            }
        });
    }

    const addEventListenersForListView = (entityNode: any) => {
        entityNode?.querySelector(`${classConstants.ENTITY_EXPAND_BTN}`)?.addEventListener('click', (e: any) => {
            e.stopPropagation();
            const inputEle = entityNode?.querySelector(`${classConstants.ENTITY_INPUT}`);
            const inputValue = inputEle?.dataset?.inputvalue;
            rootServiceInstance.showMoreTextInEntityNode(inputEle, hostInstance, inputEle?.scrollHeight, inputValue, true);
        },entityNode);
    }

    const handleAgentAssistAgentResponse = (mybotResponse: any) => {
        if (mybotResponse && Object.keys(mybotResponse).length > 0) {
            updateMybotResponse(mybotResponse);
        }
    };

    const updateMybotResponse = (data: any) => {
        rootServiceInstance.removeLoaderForAutomation(hostInstance, hostInstance?.chatEle?.querySelector(`${classConstants.MYBOT_SECTION}`) as HTMLElement);
        const responseType = rootServiceInstance.getMybotTypeOfResponse(data);
        rootServiceInstance.handlePreviousAutomationNode(currentEntityNode, data, templateClick, hostInstance);
        formatResponseBasedOnType(data, responseType);
    };

    const formatResponseBasedOnType = (data: any, responseType: string) => {
        const responseId = KoreGenerateuuidPipe();

        let result: any = hostInstance.templateRenderService.getResponseUsingTemplate(data);
        // let msgStringify = JSON.stringify(result);
        // data.temp = encodeURI(msgStringify);  
        data.templateResult = result;

        switch (responseType) {

            case RenderResponseType.AUTOMATION_NODE:
                handleAutomationNodeResponse(data, responseId);
                break;

            case RenderResponseType.SMALLTALK:
                handleSmallTalkResponse(data, responseId);
                break;

            default:
                break;
        }
    };

    const handleAutomationNodeResponse = (data: any, responseId: string) => {
        if (data?.buttons?.[0]?.value) {
            let automationNodeObj = rootServiceInstance.prepareAutomationNodeResponse(data, responseId);
            automationNodeObj = data.isPrompt
                ? rootServiceInstance.prepareEntityNodeResponse(data, automationNodeObj, hostInstance)
                : rootServiceInstance.prepareMsgNodeResponse(data, automationNodeObj, hostInstance);
            currentEntityNode = data.isPrompt ? automationNodeObj : null;
            addNodeInAutomation(automationNodeObj);
        }
    };

    const handleSmallTalkResponse = (data: any, responseId: string) => {
        if (data?.buttons?.[0]?.value) {
            let mybotDatObj = rootServiceInstance.prepareSmallTalkResponse(data, responseId);
            mybotDatObj = data.isPrompt
                ? rootServiceInstance.prepareEntityNodeResponse(data, mybotDatObj, hostInstance)
                : rootServiceInstance.prepareMsgNodeResponse(data, mybotDatObj, hostInstance);

            currentEntityNode = data.isPrompt ? mybotDatObj : null;
            rootServiceInstance.addSmallTalkTemplate(mybotDatObj, ProjConstants.MYBOT, hostInstance);
            setMybotResponseArray((prevResponse: any) => [...prevResponse, mybotDatObj]);
        }
    };

    const addNodeInAutomation = (automationNodeObj: any) => {
        setMybotResponseArray((prevResponse: any) => {
            const updatedArray = [...prevResponse];
            const lastObj = updatedArray[updatedArray.length - 1];
            if (lastObj?.type === RenderResponseType.AUTOMATION) {
                rootServiceInstance.handleErrorPrompts(lastObj, automationNodeObj, hostInstance);
                updateAutomationNode(lastObj, automationNodeObj);
                addNodeInListView(automationNodeObj, lastObj);
            }
            return updatedArray;
        });
    };

    const updateAutomationNode = (lastObj: any, automationNodeObj: any) => {
        automationNodeObj.dialogId = lastObj.dialogId;
        // rootServiceInstance.handlePreviousAutomationNode(lastObj.automationNodes[lastObj.automationNodes.length - 1], automationNodeObj, hostInstance);
        lastObj.automationNodes.push(automationNodeObj);
        const entityDisplayName = automationNodeObj?.data?.entityDisplayName || automationNodeObj?.data?.entityName;
        if (entityDisplayName) {
            updateMybotHeaderEntityName(entityDisplayName);
        }
        rootServiceInstance.addDialogTemplate(automationNodeObj, lastObj, ProjConstants.MYBOT, hostInstance);
    };

    const addNodeInListView = (automationNode: any, automation: any) => {
        if (!hostInstance?.chatEle?.querySelector(`${classConstants.LIST_VIEW_POPUP}`)?.classList?.contains(classConstants.HIDE_ELEMENT)) {
            renderEntityInListView(automationNode, automation);
        }
    }


    const updateMybotHeaderEntityName = (entityDisplayName: string) => {
        const mybotHeaderEntityName = hostInstance?.chatEle?.querySelector(`${classConstants.MYBOT_HEADER_ENTITY_NAME}`);
        mybotHeaderEntityName.innerText = entityDisplayName;
    };

    const renderEntityInListView = (entity: any, automation: any) => {
        if (entity?.type === RenderResponseType.AUTOMATION_NODE && entity?.nodeType === RenderResponseType.ENTITY_NODE) {
            let manualMode = true;
            let payload: any = { entityNode: entity, activeTab: ProjConstants.MYBOT, manualMode, view: 'listView' }
            let template : any = '';
            if(entity.data.entityType != 'attachment'){
                template = getHTML(AskCustomer, payload, hostInstance);
            }else{
                entity.fileObj = {};
                template = getHTML(MybotAttachmentAskCustomer, payload, hostInstance);
            }   
            hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, template, {
                event: SDK_EVENTS.ASK_CUSTOMER_TEMPLATE,
                data: payload
            });
            rootServiceInstance.handleEntityNodeClickEvents(template, entity, ProjConstants.MYBOT, hostInstance);
            let listViewWrapper: any = hostInstance?.chatEle?.querySelector(`${classConstants.LIST_VIEW_BODY}`);
            listViewWrapper?.append(template);
            showLastNodeActionButtons(automation);
        }
    }


    const showLastNodeActionButtons = (lastAutomation: any) => {
        if (lastAutomation?.type === RenderResponseType.AUTOMATION || lastAutomation.type === RenderResponseType.SMALLTALK) {
            const lastObj = (lastAutomation?.type === RenderResponseType.AUTOMATION) ? lastAutomation?.automationNodes[lastAutomation.automationNodes?.length - 1] : lastAutomation;
            if (lastObj?.data?.isPrompt && lastObj.nodeType === RenderResponseType.ENTITY_NODE) {
                const askCustNode = hostInstance?.chatEle?.querySelector(`${classConstants.ASK_CUST_NODE}${lastObj.uuid}`);
                const inputEle = askCustNode?.querySelector(`${classConstants.ENTITY_INPUT}`);
                inputEle.readOnly = false;
                inputEle.placeholder = '';
            }
        }
    }


    const handleMybotScroll = () => {
        const mybotEle = hostInstance?.chatEle?.querySelector(classConstants.MYBOT_SECTION) as HTMLElement;
        mybotEle.scrollTop = mybotEle.scrollHeight;

        if (mybotResponseArray?.length > 0) {
            hideEmptyScreen();
        }
    };

    const handleDialogInterrupt = (dialog: any) => {
        if (dialog && Object.keys(dialog).length > 0) {
            const footerTag = hostInstance.chatEle.querySelector(classConstants.FOOTER);
            hostInstance.openMybotTab(footerTag, true);
            let currentDialogName = mybotResponseArray[mybotResponseArray?.length - 1]?.dialogName;
            rootServiceInstance.toggleInterruptPopup(hostInstance, true, currentDialogName);
        }
    };

    const handleTemplateClickEvents = (obj: any) => {
        if (obj.tab === Tabs.MYBOT) {
            let message = obj.messageText;
            let lastAutomation = getLastAutomation();
            templateClick = true;
            rootServiceInstance.handleTemplateClickEvents(message, Tabs.MYBOT, lastAutomation.dialogId, hostInstance);
        }
    }


    const showOrHideLastNodeActionButtons = (showInputIcons: boolean, disabled = false) => {
        const lastAutomation: any = getLastAutomation();
        if (lastAutomation?.type === RenderResponseType.AUTOMATION || lastAutomation.type === RenderResponseType.SMALLTALK) {
            const lastObj = lastAutomation?.type === RenderResponseType.AUTOMATION ? lastAutomation?.automationNodes[lastAutomation.automationNodes?.length - 1] : lastAutomation;

            if (lastObj?.data?.isPrompt && lastObj.nodeType === RenderResponseType.ENTITY_NODE) {
                const askCustNode = hostInstance?.chatEle?.querySelector(`${classConstants.ASK_CUST_NODE}${lastObj.uuid}`);
                const inputEle = askCustNode?.querySelector(`${classConstants.ENTITY_INPUT}`);
                if (!showInputIcons) {
                    if (disabled) {
                        inputEle.readOnly = true;
                        inputEle.placeholder = '';
                        inputEle.blur();
                    } else {
                        inputEle.readOnly = false;
                        inputEle.placeholder = '';
                        inputEle.focus();
                    }
                    rootServiceInstance.handleEntityInput(lastObj, hostInstance, true);
                } else {
                    showLastNodeActionButtons(lastAutomation);
                    rootServiceInstance.showEntityNodeInputButtons(askCustNode);
                }
                rootServiceInstance.toggleAttachmentDiv(askCustNode, inputEle, !showInputIcons);
                rootServiceInstance.addorRemoveAttachemntFileError(lastObj, hostInstance);
            }
        }
    };

    const addMybotScrollButtons = () => {
        addScrollButtons(
            hostInstance,
            classConstants,
            rootServiceInstance,
            {
                containerClass: classConstants.MYBOT_SECTION,
                headerClass: classConstants.MYBOT_HEADER_SECTIONS,
                upArrowClass: classConstants.MYBOT_UP_ARROW,
                downArrowClass: classConstants.MYBOT_DOWN_ARROW,
                tabType: Tabs.MYBOT
            }
        );
    };


    const fetchMybotData = async () => {
        try {
            const params = {
                botId: hostInstance.rootService.connectionDetails.botId,
                conversationId: hostInstance.rootService.connectionDetails.conversationId,
                agentassisturl: hostInstance.rootService.connectionDetails.agentassisturl,
            };

            // Fetch both history and feedback concurrently
            const [feedbackResponse, historyResponse] = await Promise.all([
                rootServiceInstance.getMybotFeedback(params, hostInstance).catch((error : any) => {
                    hostInstance.emit(SDK_EVENTS.ON_ERROR, ERROR_CODES['ERR_FEEDBACK_API_FAILURE']);
                    return { results: [] };
                }),
                rootServiceInstance.getMybotHistory(params, hostInstance).catch((error : any) => {
                    hostInstance.emit(SDK_EVENTS.ON_ERROR, ERROR_CODES['ERR_MYBOT_HISTORY_API_FAILURE']);
                    return { results: [] };
                })
            ]);

            const feedbackData = feedbackResponse?.results || [];
            const historyData = historyResponse?.results || [];
            renderHistoryMessages(historyData, feedbackData);

        } catch (error) {
            console.error('Error fetching assist data:', error);
        } finally {
            hostInstance?.webSocketService?.emitTransferEvent();
        }
    }

    const renderHistoryMessages = (historyData: any[], feedbackData: any[]) => {

        historyData.forEach((res: any) => {
            if (res.type === "outgoing") {

                let formattedHistoryItem = rootServiceInstance.formatHistoryResponseToNormalRender(res, false);

                if (!rootServiceInstance?.isMyBotAutomationOnGoing) {
                    if (formattedHistoryItem.intentName && formattedHistoryItem.positionId && formattedHistoryItem.buttons.length > 0) {
                        const dialog = rootServiceInstance.prepareDialogObjForMybotHistory(formattedHistoryItem);
                        rootServiceInstance.updateLocalStorageForMybot(hostInstance, dialog, true);
                        addAutomationNodeInMybotResponse(dialog);
                    }
                }

                if (rootServiceInstance?.isMyBotAutomationOnGoing && formattedHistoryItem.eventType === "action" && formattedHistoryItem.endOfTask === true) {
                    let feedbackObj = feedbackData.find((feedback: any) => feedback.positionId === rootServiceInstance.currentMybotAutomationId);
                    dialogTerminatedOrInterrupted(feedbackObj, true);
                    currentEntityNode = null;
                }
                rootServiceInstance.handleHistoryPreviousAutomationNode(currentEntityNode, formattedHistoryItem, hostInstance);
                const responseType = rootServiceInstance.getMybotTypeOfResponse(formattedHistoryItem);                
                formatResponseBasedOnType(formattedHistoryItem, responseType);

            }

        });

    };

    return (
        <Fragment>
            <div className="assist-data-wrapper-container">
                <div className="assist-block-content mB-block-content">
                    <div className="assist-header-content aa-mybot-header-section">
                    </div>
                    <div className="scroll-data-assist aa-mybot-section chat-widget-body-wrapper">
                        {/* all types of responses(suggestions, automation, smalltalk) */}
                    </div>
                </div>
            </div>
        </Fragment>
    )
}
